module.exports = __webpack_public_path__ + "img/photo.ff28fa49.jpg";